import { PRICE_RANGE_MAP } from 'src/search/constants';
import { PriceRange } from 'src/search/types/PriceRange';

const getPriceRange = (currencyCode: string): PriceRange => {
  const priceRange = PRICE_RANGE_MAP[currencyCode];
  if (priceRange) {
    return priceRange;
  }
  return PRICE_RANGE_MAP.USD;
};

export default getPriceRange;
